module.exports = __webpack_public_path__ + "img/markt-up-8c.17f2e93a.png";